import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentorMappingModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentorMappingFormWidgetService } from 'common/widget/mentor/mentor-map-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class MentorMappingFormResolver extends FormResolverService<MentorMappingModel> {
    constructor(
        protected fs: MentorMappingFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel: any, meta: any, widget: any) {
    //     // dataModel['student_ids']=dataModel.student_id;
    //     // dataModel['branch_id'] = null;
    //     // dataModel['group_id'] = null;
    //     // dataModel['batch_id'] = null;
    //     console.log(dataModel);
    //     return dataModel;
    // }
}
